/**
 * ArbiHunter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: ROOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class QueryFilterDTO {
    'field': string;
    'operator': QueryFilterDTOOperatorEnum;
    'value': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "field",
            "baseName": "field",
            "type": "string",
            "format": ""
        },
        {
            "name": "operator",
            "baseName": "operator",
            "type": "QueryFilterDTOOperatorEnum",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return QueryFilterDTO.attributeTypeMap;
    }

    public constructor() {
    }
}

export enum QueryFilterDTOOperatorEnum {
    EQ = 'eq',
    NE = 'ne',
    GT = 'gt',
    GTE = 'gte',
    LT = 'lt',
    LTE = 'lte',
    BETWEEN = '$between',
    IN = 'in',
    NOTIN = 'notin',
    LIKE = 'like',
    NOTLIKE = 'notlike',
    ISNULL = 'isnull',
    ISNOTNULL = 'isnotnull',
    CONT_L = '$contL'
}

